import { createStore } from 'vuex'
import userInfo from './user/UserInfo'
import area from "./area/area"
import soInfo from "./soInfo/SoInfo"
import authority from "./authority/authority"
const state = {
  PagePathStatus: true,
  PageParentBackPath: () => {
  },
  PageChildBackPath: () => {
  },
  partner: {},
  backStatus: {
    registerBack: true
  }
};

export default createStore({
  state,
  modules: {
    userInfo,
    area,
    soInfo,
    authority
  },
  plugins: [
    // createPersistedState(),
  ],
})
